import React from 'react';
import { usePermissions } from '../lib/permissionsContext';
import * as S from './ProtectedRoute.styles';

interface PagePermissionRouteProps {
  children: React.ReactNode;
  page: string;
}

export const PagePermissionRoute: React.FC<PagePermissionRouteProps> = ({ children, page }) => {
  const { hasPageAccess, loading } = usePermissions();

  if (loading) {
    return (
      <S.ProtectedRouteLoading>
        <S.ProtectedRouteSpinner>⏳</S.ProtectedRouteSpinner>
        <S.ProtectedRouteText>Проверка прав доступа...</S.ProtectedRouteText>
      </S.ProtectedRouteLoading>
    );
  }

  if (!hasPageAccess(page)) {
    return (
      <S.ProtectedRouteLoading>
        <S.ProtectedRouteSpinner>🚫</S.ProtectedRouteSpinner>
        <S.ProtectedRouteText>403 - Нет доступа к этой странице</S.ProtectedRouteText>
      </S.ProtectedRouteLoading>
    );
  }

  return <>{children}</>;
};

